import { useState } from "react";
import { IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

type Props = Omit<TextFieldProps, "type" | "size" | "variant"> & {
  testId: string;
};

/**
 * Input de contraseña del kit v2 (`lendia_input`) con el botón para mostrar u ocultar el valor,
 * igual al de `CrearCuenta`.
 */
export const TextFieldPassword = ({ testId, inputProps, ...rest }: Props) => {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      {...rest}
      size="lendia_input"
      fullWidth
      type={visible ? "text" : "password"}
      inputProps={{ ...inputProps, "data-testid": testId }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
              onClick={() => setVisible((v) => !v)}
              edge="end"
              size="small"
              sx={{ color: "text.secondary" }}
            >
              {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
